define('models/StoreBenefitCollection',['ObjectCollection', 'models/StoreBenefitModel'],
    function (ObjectCollection, StoreBenefitModel) {
        //
        // StoreBenefitCollection
        //
        var StoreBenefitCollection = ObjectCollection.extend({
            model: StoreBenefitModel,
            
            getSearchable:function(){
                var searchable = [];
                this.each(function(model){
                    if (model.get('search'))
                    searchable.push(model)
                });
                return _(searchable);
            }
        });


        return StoreBenefitCollection;

    });
